/**
 * Build display labels for WPS bevel rows (matches FloorSheet `wpsBevelOptions`).
 */
export function bevelLabelForIndex(
  bevelSection: Record<string, unknown> | null | undefined,
  bevelIndex: number | null | undefined
): string {
  if (bevelIndex === null || bevelIndex === undefined || !Number.isFinite(bevelIndex)) {
    return ''
  }
  const list = Array.isArray(bevelSection?.bevels) ? bevelSection!.bevels : []
  const entry = list[bevelIndex]
  const jointTypeRaw = entry && typeof entry === 'object' ? (entry as { jointType?: unknown }).jointType : undefined
  const jointType = Array.isArray(jointTypeRaw)
    ? jointTypeRaw.filter((value): value is string => typeof value === 'string' && value.trim() !== '')
    : []
  const suffix = jointType.length > 0 ? ` — ${jointType.join(', ')}` : ''
  return `Bevel ${bevelIndex + 1}${suffix}`
}
